import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { ChartContentV2 } from './ChartContentV2'
import { useGetChart } from './useGetChart'
import { TileFilter } from '../shared/TileFilter'

export const ChartComponent = ({
  id,
  tileContainerRef,
}: {
  id: string
  tileContainerRef: React.RefObject<HTMLDivElement>
}) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChart(id, tileFilterSelections)

  return (
    <ChartContentV2
      data={data}
      tileFilters={<TileFilter schema={data.filters} />}
      tileContainerRef={tileContainerRef}
    />
  )
}
